import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        '@$': 'title',
      },
      type: 'table',
      content: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'piSwitch',
                },
                true,
              ],
            },
            {
              '{}': {
                query: {
                  '`': {
                    filter: {
                      or: [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'orgRecordId',
                              },
                            },
                            null,
                          ],
                        },
                        {
                          '=': [
                            {
                              '@.': [
                                '!org',
                                {
                                  ref: {
                                    entity: {
                                      '``': {
                                        '@$': 'orgEntityId',
                                      },
                                    },
                                  },
                                },
                              ],
                            },
                            {
                              '``': {
                                '@$': 'orgRecordId',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    target: 'ent:!personnel:!employee',
                    selection: {
                      '{}': {
                        fields: {
                          '{}': {
                            '2022': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2022',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2023': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2023',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2024': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2024',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            code: {
                              '{}': {
                                value: {
                                  '@.': '!code',
                                },
                              },
                            },
                            name: {
                              '{}': {
                                value: {
                                  '@.': '!name',
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    subqueries: {
                      projects: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!proj',
                        },
                        using: 'projectPiAssignments',
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': [
                                    '!org',
                                    {
                                      ref: {
                                        entity: {
                                          '``': {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!projects:!proj',
                      },
                      expenses2022: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            includesStart: true,
                            end: {
                              $date: '12/31/2022',
                            },
                            start: {
                              $date: '1/1/2022',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          project: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                          },
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!projects#!proj:!award',
                            },
                            using: 'project',
                            target: 'ent:!awards:!award',
                            selection: {
                              '@.': '!research_type',
                            },
                          },
                        },
                      },
                      expenses2023: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            includesStart: true,
                            end: {
                              $date: '12/31/2023',
                            },
                            start: {
                              $date: '1/1/2023',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          project: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                          },
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!projects#!proj:!award',
                            },
                            using: 'project',
                            target: 'ent:!awards:!award',
                            selection: {
                              '@.': '!research_type',
                            },
                          },
                        },
                      },
                      expenses2024: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            includesStart: true,
                            end: {
                              $date: '12/31/2024',
                            },
                            start: {
                              $date: '1/1/2024',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          project: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                          },
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!projects#!proj:!award',
                            },
                            using: 'project',
                            target: 'ent:!awards:!award',
                            selection: {
                              '@.': '!research_type',
                            },
                          },
                        },
                      },
                      projectPiAssignments: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!pi',
                        },
                        target: 'ent:!proj_pis:!entry',
                      },
                    },
                  },
                },
                totalRow: {
                  '`': {
                    selection: {
                      '{}': {
                        fields: {
                          '{}': {
                            name: { '{}': { value: 'Total' } },
                            code: { '{}': { value: 'Total' } },
                            '2022': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      { '@': 'records' },
                                      { '@>': [{ '@$': '$value' }, '2022'] },
                                    ],
                                  },
                                },
                              },
                            },
                            '2023': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      { '@': 'records' },
                                      { '@>': [{ '@$': '$value' }, '2023'] },
                                    ],
                                  },
                                },
                              },
                            },
                            '2024': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      { '@': 'records' },
                                      { '@>': [{ '@$': '$value' }, '2024'] },
                                    ],
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    subqueries: {
                      records: {
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': [
                                    '!org',
                                    {
                                      ref: {
                                        entity: {
                                          '``': {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!personnel:!employee',
                        selection: {
                          '{}': {
                            '2022': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2022',
                                  },
                                },
                                0,
                              ],
                            },
                            '2023': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2023',
                                  },
                                },
                                0,
                              ],
                            },
                            '2024': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2024',
                                  },
                                },
                                0,
                              ],
                            },
                          },
                        },
                        subqueries: {
                          projects: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              or: [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  '=': [
                                    {
                                      '@.': [
                                        '!org',
                                        {
                                          ref: {
                                            entity: {
                                              '``': {
                                                '@$': 'orgEntityId',
                                              },
                                            },
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                          },
                          expenses2022: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                includesStart: true,
                                end: {
                                  $date: '12/31/2022',
                                },
                                start: {
                                  $date: '1/1/2022',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              project: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                              },
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!projects#!proj:!award',
                                },
                                using: 'project',
                                target: 'ent:!awards:!award',
                                selection: {
                                  '@.': '!research_type',
                                },
                              },
                            },
                          },
                          expenses2023: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                includesStart: true,
                                end: {
                                  $date: '12/31/2023',
                                },
                                start: {
                                  $date: '1/1/2023',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              project: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                              },
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!projects#!proj:!award',
                                },
                                using: 'project',
                                target: 'ent:!awards:!award',
                                selection: {
                                  '@.': '!research_type',
                                },
                              },
                            },
                          },
                          expenses2024: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                includesStart: true,
                                end: {
                                  $date: '12/31/2024',
                                },
                                start: {
                                  $date: '1/1/2024',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              project: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                              },
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!projects#!proj:!award',
                                },
                                using: 'project',
                                target: 'ent:!awards:!award',
                                selection: {
                                  '@.': '!research_type',
                                },
                              },
                            },
                          },
                          projectPiAssignments: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!pi',
                            },
                            target: 'ent:!proj_pis:!entry',
                          },
                        },
                      },
                    },
                  },
                },
                columns: {
                  '[]': [
                    {
                      '{}': {
                        id: 'code',
                        direct: {
                          '{}': {
                            name: 'Code',
                            type: 'TEXT',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: 'name',
                        direct: {
                          '{}': {
                            name: 'Name',
                            type: 'TEXT',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2022',
                        direct: {
                          '{}': {
                            name: '2022',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2023',
                        direct: {
                          '{}': {
                            name: '2023',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2024',
                        direct: {
                          '{}': {
                            name: '2024',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                  ],
                },
              },
            },
          ],
          {
            '{}': {
              query: {
                '`': {
                  filter: {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          '2022': {
                            '{}': {
                              value: {
                                '+': {
                                  '@': 'expenses2022',
                                },
                              },
                            },
                          },
                          '2023': {
                            '{}': {
                              value: {
                                '+': {
                                  '@': 'expenses2023',
                                },
                              },
                            },
                          },
                          '2024': {
                            '{}': {
                              value: {
                                '+': {
                                  '@': 'expenses2024',
                                },
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                        },
                      },
                      onClick: {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          title: {
                                            if: [
                                              [
                                                {
                                                  '=': [
                                                    {
                                                      '@_': 'id',
                                                    },
                                                    'ent:!org:!dept',
                                                  ],
                                                },
                                                'PI',
                                              ],
                                              {
                                                '@_': ['child', 'name'],
                                              },
                                            ],
                                          },
                                          piSwitch: {
                                            if: [
                                              [
                                                {
                                                  '=': [
                                                    {
                                                      '@_': 'id',
                                                    },
                                                    'ent:!org:!dept',
                                                  ],
                                                },
                                                true,
                                              ],
                                              false,
                                            ],
                                          },
                                          orgEntityId: {
                                            '@_': 'id',
                                          },
                                          orgRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'trends',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    expenses2022: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          includesStart: true,
                          end: {
                            $date: '12/31/2022',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        project: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                        },
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!projects#!proj:!award',
                          },
                          using: 'project',
                          target: 'ent:!awards:!award',
                          selection: {
                            '@.': '!research_type',
                          },
                        },
                      },
                    },
                    expenses2023: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          includesStart: true,
                          end: {
                            $date: '12/31/2023',
                          },
                          start: {
                            $date: '1/1/2023',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        project: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                        },
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!projects#!proj:!award',
                          },
                          using: 'project',
                          target: 'ent:!awards:!award',
                          selection: {
                            '@.': '!research_type',
                          },
                        },
                      },
                    },
                    expenses2024: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          includesStart: true,
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2024',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        project: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                        },
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!projects#!proj:!award',
                          },
                          using: 'project',
                          target: 'ent:!awards:!award',
                          selection: {
                            '@.': '!research_type',
                          },
                        },
                      },
                    },
                    projectAssignments: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      target: 'ent:!projects:!proj',
                    },
                  },
                },
              },
              totalRow: {
                '`': {
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          name: { '{}': { value: 'Total' } },
                          code: { '{}': { value: 'Total' } },
                          '2022': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    { '@': 'records' },
                                    { '@>': [{ '@$': '$value' }, '2022'] },
                                  ],
                                },
                              },
                            },
                          },
                          '2023': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    { '@': 'records' },
                                    { '@>': [{ '@$': '$value' }, '2023'] },
                                  ],
                                },
                              },
                            },
                          },
                          '2024': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    { '@': 'records' },
                                    { '@>': [{ '@$': '$value' }, '2024'] },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    records: {
                      filter: {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      target: 'dim::!org',
                      selection: {
                        '{}': {
                          '2022': {
                            '+': {
                              '@': 'expenses2022',
                            },
                          },
                          '2023': {
                            '+': {
                              '@': 'expenses2023',
                            },
                          },
                          '2024': {
                            '+': {
                              '@': 'expenses2024',
                            },
                          },
                        },
                      },
                      subqueries: {
                        expenses2022: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              includesStart: true,
                              end: {
                                $date: '12/31/2022',
                              },
                              start: {
                                $date: '1/1/2022',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            project: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                            },
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!projects#!proj:!award',
                              },
                              using: 'project',
                              target: 'ent:!awards:!award',
                              selection: {
                                '@.': '!research_type',
                              },
                            },
                          },
                        },
                        expenses2023: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              includesStart: true,
                              end: {
                                $date: '12/31/2023',
                              },
                              start: {
                                $date: '1/1/2023',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            project: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                            },
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!projects#!proj:!award',
                              },
                              using: 'project',
                              target: 'ent:!awards:!award',
                              selection: {
                                '@.': '!research_type',
                              },
                            },
                          },
                        },
                        expenses2024: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              includesStart: true,
                              end: {
                                $date: '12/31/2024',
                              },
                              start: {
                                $date: '1/1/2024',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            project: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                            },
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!projects#!proj:!award',
                              },
                              using: 'project',
                              target: 'ent:!awards:!award',
                              selection: {
                                '@.': '!research_type',
                              },
                            },
                          },
                        },
                        projectAssignments: {
                          ref: {
                            attr: 'attr:ent#!projects#!proj:!org',
                            inherit: '-',
                          },
                          target: 'ent:!projects:!proj',
                        },
                      },
                    },
                  },
                },
              },
              columns: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      direct: {
                        '{}': {
                          name: 'Code',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      direct: {
                        '{}': {
                          name: 'Name',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2022',
                      direct: {
                        '{}': {
                          name: '2022',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2023',
                      direct: {
                        '{}': {
                          name: '2023',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2024',
                      direct: {
                        '{}': {
                          name: '2024',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    title: 'Division',
    piSwitch: false,
  },
}
